/**
 * ContentTag Component
 * Simple component that wraps slot content with the specified HTML element
 * @module common/ContentTag
 */
export default {
  name: 'ContentTag',
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  render (h) {
    return h(this.tag, {
      attrs: this.$attrs
    }, [
      this.$slots.default
    ])
  }
}



// WEBPACK FOOTER //
// ./frontend/src/components/common/ContentTag.js